import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class DepartementService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification/liste-departement'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getDepartementsByEtablissement = async (idEtablissement) => {
  const response = await axios.get(`${this.API_URL}?idEtablissement=${idEtablissement}`);
  return response.data;
};

}